<form class="bo-dialog site-create" (ngSubmit)="onAdd()" #shopForm="ngForm">
  <header class="bo-dialog__head">
    <span class="bo-dialog__icon"><i class="bi bi-shop" aria-hidden="true"></i></span>
    <div class="bo-dialog__heading"><h2 id="shop-create-title">{{ 'site_setup_create_title' | translate }}</h2><p>{{ 'site_setup_create_intro' | translate }}</p></div>
    <button type="button" class="bo-dialog__close" [attr.aria-label]="'ac_close' | translate" [disabled]="isAdding" (click)="activeModal.dismiss()"><i class="bi bi-x-lg" aria-hidden="true"></i></button>
  </header>

  <div class="bo-dialog__body">
    <app-site-setup-illustration stage="identity" [shopName]="inputValue"></app-site-setup-illustration>
    <div class="site-create__field">
      <label for="new-shop-name">{{ 'auth_shop_name_placeholder' | translate }}</label>
      <input id="new-shop-name" name="shopName" type="text" class="form-control" ngbAutofocus required
        [ngModel]="inputValue" (ngModelChange)="validateShopName($event)" [disabled]="isAdding"
        [placeholder]="'site_setup_name_placeholder' | translate" autocomplete="off" autocapitalize="none" spellcheck="false"
        [attr.aria-invalid]="nameInvalid" aria-describedby="shop-name-feedback shop-address-caption" />
      <div id="shop-name-feedback" class="site-create__feedback" aria-live="polite" [class.is-error]="nameInvalid || validationError" [class.is-valid]="validName === true" [class.is-checking]="isChecking">
        <span *ngIf="isChecking" class="bo-dialog__spinner" aria-hidden="true"></span>
        <i *ngIf="!isChecking && (validName === true || nameInvalid || validationError)" class="bi" [ngClass]="validName === true ? 'bi-check2-circle' : 'bi-info-circle'" aria-hidden="true"></i>
        <span>{{ validationKey | translate }}</span>
        <button *ngIf="validationError" type="button" class="site-create__retry" (click)="validateShopName()">{{ 'ac_retry' | translate }}</button>
      </div>
    </div>
    <div class="site-create__address" *ngIf="storeDomain">
      <span class="site-create__address-icon"><i class="bi bi-globe2" aria-hidden="true"></i></span>
      <div><span id="shop-address-caption">{{ 'site_setup_web_address' | translate }}</span><bdi dir="ltr"><strong>{{ normalizedName || ('site_setup_address_placeholder' | translate) }}</strong><span>.{{ storeDomain }}</span></bdi></div>
      <i *ngIf="validName === true" class="bi bi-check2 site-create__address-check" aria-hidden="true"></i>
    </div>
    <p class="site-create__note"><i class="bi bi-palette2" aria-hidden="true"></i>{{ 'site_setup_customize_later' | translate }}</p>
  </div>

  <footer class="bo-dialog__foot">
    <button type="button" class="bo-dialog__button" (click)="activeModal.dismiss()" [disabled]="isAdding">{{ 'ac_cancel' | translate }}</button>
    <button type="submit" class="bo-dialog__button bo-dialog__button--primary" [disabled]="!canSubmit">
      <span *ngIf="isAdding" class="bo-dialog__spinner" aria-hidden="true"></span>
      {{ 'site_setup_create_action' | translate }}<i *ngIf="!isAdding" class="bi bi-arrow-right" aria-hidden="true"></i>
    </button>
  </footer>
</form>
